import { Controller } from "stimulus"
import { gsap } from "gsap"

export default class extends Controller {
  connect() {
    this.lastScrollPosition = window.scrollY
    this.isVisible = true

    this.hideIfScrollingDone = this.hideIfScrollingDone.bind(this)

    window.addEventListener('scroll', this.hideIfScrollingDone, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.hideIfScrollingDone)
  }

  hideIfScrollingDone() {
    const currentScroll = window.scrollY
    const scrollingDown = currentScroll > this.lastScrollPosition

    // Don't trigger animation if at the top of the page
    if (currentScroll <= 0) {
      this.showMenu()
      this.lastScrollPosition = currentScroll
      return
    }

    if (scrollingDown && this.isVisible) {
      this.hideMenu()
    } else if (!scrollingDown && !this.isVisible) {
      this.showMenu()
    }

    this.lastScrollPosition = currentScroll
  }

  hideMenu() {
    this.isVisible = false
    gsap.to(this.element, {
      opacity: 0.2,
      duration: 0.3,
      ease: "power2.out"
    })
  }

  showMenu() {
    this.isVisible = true
    gsap.to(this.element, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out"
    })
  }
}
